/**
 * Returns the schedule disclaimer text. When owner approval is required, includes owner's approval; otherwise omitted.
 * @param {string} [ownerApproval] - "Y" when owner approval is required
 * @returns {string}
 */
export const getScheduleDisclaimer = (ownerApproval) =>
    ownerApproval === "Y"
        ? "All times shown in local time. Aircraft is subject to owner's approval, continued availability of aircraft and crew, slots and permits."
        : "All times shown in local time. Aircraft is subject to continued availability of aircraft and crew, slots and permits.";
